var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#CF3126",
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.714 19.857c0-.303-.122-.524-.368-.663l-6.286-3.928c-.253-.164-.52-.172-.798-.025a.731.731 0 0 0-.405.688v7.857c0 .31.135.54.405.687a.85.85 0 0 0 .38.098.7.7 0 0 0 .418-.122l6.286-3.929c.246-.139.368-.36.368-.663zm6.286 0c0 .786-.004 1.4-.012 1.842-.008.442-.043 1-.105 1.675a13.569 13.569 0 0 1-.276 1.811 2.872 2.872 0 0 1-.847 1.51c-.434.41-.941.647-1.522.712-1.817.205-4.563.307-8.238.307s-6.42-.102-8.238-.307a2.617 2.617 0 0 1-1.528-.712 2.854 2.854 0 0 1-.853-1.51 15.196 15.196 0 0 1-.264-1.81 24.082 24.082 0 0 1-.105-1.676C9.004 21.257 9 20.643 9 19.857s.004-1.4.012-1.841c.008-.442.043-1 .105-1.676.061-.675.153-1.279.276-1.811.13-.597.413-1.1.847-1.51.434-.41.941-.647 1.522-.712C13.58 12.102 16.325 12 20 12s6.42.102 8.238.307c.58.065 1.09.303 1.528.712.438.41.722.913.853 1.51.115.532.203 1.136.264 1.81.062.676.097 1.235.105 1.677.008.442.012 1.055.012 1.841z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.71af0667f505612868ecdbaf6ad4a715.svg";
export { ForwardRef as ReactComponent };